// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq_-n4PF{background-color:#fff;width:100%;transition:opacity .3s}.contentWrap_3IzlA{padding-left:30px;padding-right:30px;margin:145px auto 0;max-width:800px;box-sizing:content-box}@media only screen and (min-width:800px){.contentWrap_3IzlA{padding-left:40px;padding-right:40px}}@media only screen and (min-width:1150px){.contentWrap_3IzlA{padding-left:0 40px;padding-right:0 40px}}@media only screen and (min-width:800px){.contentWrap_3IzlA{margin-top:160px}}.categoryNav_2LEW1{display:flex;justify-content:center}.category_33zqt{margin:0 5px;padding:15px;color:#242b59;font-size:12px;font-weight:700;letter-spacing:.1rem;text-transform:uppercase}.category_33zqt.nuxt-link-exact-active{color:#ec853c}@media only screen and (min-width:450px){.category_33zqt{margin:0 15px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteHeaderHeightSmall": "70px",
	"siteHeaderHeight": "80px",
	"faq": "faq_-n4PF",
	"contentWrap": "contentWrap_3IzlA",
	"categoryNav": "categoryNav_2LEW1",
	"category": "category_33zqt"
};
module.exports = ___CSS_LOADER_EXPORT___;
